export type Dictionary = {
  [key: string]: string;
};

export type Translate = (
  key: string,
  interpolation?: (string | number)[],
  defaultValue?: string,
  shouldReturnEmptyTranslation?: boolean
) => string;
